<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">EDITAR INFORMACION LEGAL</h4>
        <b-row align-h="center">
            <b-col cols="12">
                <b-card
                    :header="form.title"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    align="center"
                    class="text-center my-4">
                    <b-form id="formEditor" @submit.stop.prevent="submit">
                        <b-row align-h="center">
                            <b-col cols="12" class="pb-4">
                                <ckeditor v-model="form.content" :editorUrl="editorUrl" :config="editorConfig"/>
                            </b-col>
                            <b-col cols="12" md="6" class="pb-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow px-5"
                                          form="formEditor" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="patch-check-fill" aria-hidden="true" v-else></b-icon>
                                    &nbsp;&nbsp;<span>Actualizar</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "Legal",
    props: [ 'user' ],
    data: () => ({
        loading: false,
        form: {},
        options: [],
        editorUrl: 'https://cdn.ckeditor.com/4.13.1/full-all/ckeditor.js',
        editorConfig: {
            toolbarGroups: [
                { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                { name: 'forms', groups: [ 'forms' ] },
                '/',
                { name: 'colors', groups: [ 'colors' ] },
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                '/',
                { name: 'links', groups: [ 'links' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'styles', groups: [ 'styles' ] },
                { name: 'tools', groups: [ 'tools' ] },
                { name: 'others', groups: [ 'others' ] },
                { name: 'about', groups: [ 'about' ] }
            ],
            removeButtons: 'Save,NewPage,Preview,Print,Templates,Flash,Maximize,ShowBlocks,About',
            removeDialogTabs: 'image:advanced;link:advanced',
            autoParagraph: false,
            format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
            extraAllowedContent: 'span;ul;li;table;th;td;center;br;style;*[id];*(*);*{*}',
            resize_enabled: false,
            enterMode: 'CKEDITOR.ENTER_P',
            shiftEnterMode: 'CKEDITOR.ENTER_BR',
            toolbarCanCollapse: true,
            language: 'es',
            height: '360'
        }
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'legalpage');
    },
    created () {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/settings/legal').then((res) => {
                this.form = res.data.terms;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                axios.post('/api/settings/legal', this.form).then(res => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            })
        }
    }
}
</script>

<style scoped>

</style>
